import './TicketsOverviewLoader.less';

import TicketPage from '@/mytickets/components/ticket-page/TicketPage';
import TicketsOverviewFilterButton from '@/mytickets/overview/views/TicketsOverviewFilter';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';
import React from 'react';
import i18n from '@i18n';
import { MY_TICKETS } from '@/routing/routes';

function TicketsOverviewLoader() {
    return (
        <TicketPage active={MY_TICKETS} filters={<TicketsOverviewFilterButton />}>
            <div className="ticket-content">
                <div className="ticket-group">
                    <h2>
                        <div className={'title-loader wave-animation'} />{' '}
                    </h2>
                    <MultipleComponentsLoader itemsCount={8} componentLoader={TicketOverviewLoader} />
                </div>
            </div>
        </TicketPage>
    );
}

export function TicketOverviewLoader() {
    return (
        <div className="ticket loader">
            <div className="border">
                <div className="ticket-data-row">
                    <div className="ticket-title">
                        <div className="ticket-title-loader wave-animation" />
                    </div>
                    <span className="alias wave-animation" />
                </div>
                <div className="ticket-data-row">
                    <div>
                        <span className="submit-date wave-animation" />
                        <span>
                            {i18n('ticketus.ticket.betslipStake')}
                            <b className="wave-animation" />
                        </span>
                    </div>
                    <span>
                        {i18n('ticketus.ticket.betslipOdds')}
                        <b className="wave-animation" />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default TicketsOverviewLoader;
